<template>
  <div
    class="videoList-box"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!--操作栏-->
    <refreshbtn @refesh="refesh">
      <template slot="search-btns">
        <el-button type="success" size="small" v-has="'/api/customer/product/create'" @click="addFromMethod">添加</el-button>
      </template>
    </refreshbtn>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      height="580"
      :key="updataSta"
    >
      <el-table-column
        prop="id"
        label="产品Id"
        align="center"
        width="140"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.product_id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cat_id"
        label="产品密钥"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.secret_key || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="product_name" label="产品名称" align="center">
      </el-table-column>
      <el-table-column
        label="是否启用"
        align="center"
        width="120"
        prop="weight"
      >
        <template slot-scope="scope">
          <el-switch
            @change="updateData(scope.row)"
            v-model="scope.row.enable"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="接入时间"
        prop="create_time"
        align="center"
        width="220"
      >
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        align="center"
        width="220"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-has="'/api/customer/product/update'" @click="editForm(scope.row)">
            编辑
          </el-button>
          <el-button type="text" size="small" @click="changeTags(scope.row)">
            标签管理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <!-- 分页组件 -->
    <div class="bottom">
      <div class="page">
        <el-pagination
          :page-sizes="[10, 25, 50, 100]"
          :current-page="params.page"
          :page-size="params.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
    <addProduct ref="addForm"></addProduct>
    <changeTag ref="changeTagFrom"></changeTag>
  </div>
</template>

<script>
import addProduct from "./components/addProduct.vue";
import changeTag from "./components/changeTag.vue"
import API from "@/api";

export default {
  data() {
    return {
      // 请求列表查询
      params: {
        page: 1,
        size: 10,
        product_name: "",
      },
      loading: false,
      // 列表数据
      tableData: [],
      cateData: [],
      total: "",
      dialogVisible: false,
      updataSta: false,
      isRefesh:true,
    };
  },
  components: {
    addProduct,
    changeTag
  },
  created() {
    let listRule = '/api/customer/product/list'
    let obj = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem('btnPower'))));
    if(obj[listRule]){
      this.isRefesh = true
      this.getList()
    }else{
      this.isRefesh = false 
    }
  },
  methods: {
    refesh(){
      this.isRefesh?this.getList():''
    },
    async updateData(row) {
      await API.updateProduct(row);
    },
    addFromMethod() {
      this.$refs.addForm.addFormData();
    },
    editForm(data) {
      this.$refs.addForm.editData(this._.cloneDeep(data));
    },
    changeTags(data){
      this.$refs.changeTagFrom.openDialogFun(data)
    },
    getList() {
      this.loading = true
      API.getProductList(this.params)
        .then((res) => {
          if (res.code === 0 && res.data.data) {
            this.tableData = res.data.data;
            this.tableData.forEach((item) => {
              const timestampUpdate = item.update_time * 1000;
              const timestampCreate = item.create_time * 1000;
              const dateUp = new Date(timestampUpdate);
              const dateCr = new Date(timestampCreate);
              item.update_time = dateUp.toLocaleString();
              item.create_time = dateCr.toLocaleString();
            });
            this.total = res.data.pagination.count;
            this.loading = false;
          } else if (res.code === 401) {
            this.$message.error("登陆信息过期,请重新登陆!");
            this.loading = false;
            return;
          } else {
            this.tableData = [];
            this.total = 0;
            this.loading = false;
          }
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },

    // 分页条数改变回调
    changeSize(size) {
      this.params.size = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.page = number;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}

.videoList-box {
  min-height: 100vh;
  overflow-y: auto;
}

.bottom {
  margin-top: 20px;

  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.el-pagination {
  margin-top: 0 !important;
}

.dialog-footer {
  left: 0;
}

.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
